export default __webpack_public_path__ + "static/media/520.3f4454bc.png";